import { NgModule } from 'ng-metadata/core';
import { ApiService } from 'services/api.service';
import { AuthService } from './auth.service';
import { BugsnagService } from './bugsnag.service';
import { CartService } from './cart.service';
import { ContentService } from './content.service';
import { CurrencyService } from 'services/currency.service';
import { DialogService } from './dialog.service';
import { EcommerceService } from './ecommerce.service';
import { FacilityService } from './facility.service';
import { OrderService } from './order.service';
import { PopulateService } from 'services/populate.service';
import { ProductService } from './product.service';
import { SearchService } from './search.service';
import { SessionService } from './session.service';
import { EtomsService } from './etoms.service';

@NgModule({
  declarations: [],
  providers: [
    ApiService,
    AuthService,
    BugsnagService,
    CartService,
    ContentService,
    CurrencyService,
    DialogService,
    EcommerceService,
    FacilityService,
    OrderService,
    PopulateService,
    ProductService,
    SearchService,
    SessionService,
    EtomsService,
  ],
})
export class ServicesModule {}



// WEBPACK FOOTER //
// ./resources/assets/js/services/services.module.ts